"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppPaySystemWalletsReceivesListCtl = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletsReceivesListCtl, _super);
    function AppPaySystemWalletsReceivesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_blockchain_transaction = UIUtils_1.UIUtils.IProp2Str(function (o) { o.blockchain_transaction; });
        _this.dk_wallet_from = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_from; });
        _this.dk_wallet_to = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_to; });
        _this.dk_pool_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pool_tag; });
        _this.dk_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_blockchain = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_blockchain; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPaySystemWalletsReceivesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AppPaySystemWalletsReceivesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AppPaySystemWalletsReceivesListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListInnerPayWalletReceivesByFiltersGet.exec({
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            inner_pay_wallet_id: data.inner_pay_wallet_id
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    blockchain_transaction: resp.list[i].blockchain_transaction,
                    wallet_from: resp.list[i].wallet_from,
                    wallet_to: resp.list[i].wallet_to,
                    pool_tag: resp.list[i].pool_tag,
                    amount: resp.list[i].amount,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_blockchain: moment(resp.list[i].date_blockchain_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return AppPaySystemWalletsReceivesListCtl;
}(BaseController_1.BaseController));
exports.AppPaySystemWalletsReceivesListCtl = AppPaySystemWalletsReceivesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ctl/AppPaySystemWalletsReceivesListCtl.ts
// module id = 1058
// module chunks = 0